import { motion } from "framer-motion";

const ease = [0.16, 1, 0.3, 1];

/**
 * Masked line-by-line reveal.
 * Splits text into lines and animates each with an overflow-hidden mask.
 */
export default function MaskedReveal({
  lines = [],
  delay = 0,
  stagger = 0.14,
  className = "",
  as: Tag = "h1",
}) {
  return (
    <Tag className={className}>
      {lines.map((line, i) => (
        <span key={i} className="mask-line">
          <motion.span
            initial={{ y: "115%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1.05, ease, delay: delay + i * stagger }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
}
